import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgWheatExclamation = forwardRef((props, ref) => /* @__PURE__ */ jsx(BaseIcon, { fill: "none", ref, ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.54 15.46c-.155.05-.83-1.917-.898-2.362-.088-.569.031-1.77.15-1.796.12-.027.687 1.24.756 1.686.07.444.147 2.421-.008 2.472m0 0c-.008-.163 2.067-.305 2.514-.257.572.062 1.701.488 1.696.61-.005.123-1.376.343-1.824.294-.447-.048-2.377-.484-2.386-.647m3.715-3.715L4 20m8.255-8.255 6.604-6.604m-6.604 6.604c-.155.05-.83-1.917-.898-2.362-.089-.569.03-1.77.15-1.796s.687 1.241.756 1.686c.07.445.147 2.422-.008 2.472m0 0c-.008-.163 2.066-.305 2.514-.256.572.062 1.701.488 1.696.61-.005.123-1.377.342-1.824.294s-2.378-.485-2.386-.648M20 8.953l-1.271 1.271M15.047 4l-1.271 1.271M19.99 20H20m-.01-3v-3M5.27 18.73c-.156.05-.83-1.917-.899-2.361-.088-.57.031-1.77.151-1.797s.687 1.242.756 1.686c.069.445.147 2.422-.008 2.472m0 0c-.009-.163 2.066-.304 2.513-.256.573.062 1.702.488 1.696.61-.005.123-1.376.343-1.824.294-.447-.048-2.377-.484-2.385-.647"
  }
) }));

export { SvgWheatExclamation as default };
//# sourceMappingURL=wheat-exclamation.mjs.map
